import AdminRequest from './AdminRequest';

/**
 * Provides a set of operations around API: /flows.
 */
export default class FlowsClient extends AdminRequest {
	constructor() {
		super('');
	}

	/**
	 * Fires a POST request to create an unbound flow.
	 *
	 * @param {Object} flow - The flow to be created.
	 */
	createFlow(flow) {
		const shallow = Object.assign({}, flow);
		// This is not part of the flow definition.
		delete shallow['x-validation'];
		return this._op('post', `${this.uri}/flows`, shallow);
	}

	getFlow(flowId) {
		const id = encodeURIComponent(flowId);
		return this._op('get', `${this.uri}/flows/${id}`, null);
	}

	validateFlow(flow, cancelCallback = null) {
		const shallow = Object.assign({}, flow);
		// This is not part of the flow definition.
		delete shallow['x-validation'];
		return this._op('put', `${this.uri}/flows/validate`, shallow, null, null, cancelCallback);
	}

	saveFlow(flowId, flow) {
		const id = encodeURIComponent(flowId);
		const shallow = Object.assign({}, flow);
		// This is not part of the flow definition.
		delete shallow['x-validation'];
		return this._op('post', `${this.uri}/flows/${id}`, shallow);
	}

	getFlowTriggers(flowId) {
		return this._op('get', `${this.uri}/flows/${flowId}/bindings`);
	}

	getFlowsSummaries() {
		return this._op('get', `${this.uri}/flows`);
	}

	deleteFlow(flowId) {
		const id = encodeURIComponent(flowId);
		return this._op('delete', `${this.uri}/flows/${id}`);
	}
}
